import { apiService } from '../service/api.service'

const GET_DASHBOARD_SUMMARY = 'getDashboardSummary'

const emptySummary = () => ({
  range: { start: '', end: '' },
  users: { total: 0, active: 0, blocked: 0, verified: 0, new_today: 0, new_7d: 0, new_in_range: 0 },
  devices: { total: 0, active: 0 },
  licences: { total: 0, active: 0, expired: 0 },
  dockers: { total: 0 },
  logs: { errors_range: 0, total_range: 0 },
  licences_by_type: [],
  users_by_role: [],
  logs_by_level: [],
  users_growth: [],
  recent_users: [],
  expiring_licences: [],
  clients_by_version: [],
  clients_by_jetpack: [],
  recent_clients: [],
  recent_logs: []
})

const state = {
  summary: emptySummary(),
  emailStats: null,
  loading: false,
  error: null
}

const getters = {
  dashboardSummary: state => state.summary,
  dashboardEmailStats: state => state.emailStats,
  dashboardLoading: state => state.loading,
  dashboardError: state => state.error
}

const actions = {
  async [GET_DASHBOARD_SUMMARY] (context, payload = {}) {
    context.commit('setDashboardLoading', true)
    context.commit('setDashboardError', null)

    const params = {}
    if (payload.start) params.start = payload.start
    if (payload.end) params.end = payload.end

    // Ana özet kritik; email eksikse dashboard yine çalışır.
    // Servis sağlığı ayrıca Dashboard bileşeninde (Cordatus Services ile aynı
    // mantıkla) kontrol edilir.
    const [summaryRes, emailRes] = await Promise.allSettled([
      apiService.get('admin-dashboard-summary', { params }),
      apiService.get('admin-email-logs/stats')
    ])

    if (summaryRes.status === 'fulfilled') {
      context.commit('setDashboardSummary', summaryRes.value.data.data)
    } else {
      context.commit('setDashboardError', 'Failed to load summary data.')
    }

    if (emailRes.status === 'fulfilled') {
      context.commit('setDashboardEmailStats', emailRes.value.data.data)
    }

    context.commit('setDashboardLoading', false)
  }
}

const mutations = {
  setDashboardSummary (state, payload) {
    state.summary = { ...emptySummary(), ...payload }
  },
  setDashboardEmailStats (state, payload) {
    state.emailStats = payload
  },
  setDashboardLoading (state, payload) {
    state.loading = payload
  },
  setDashboardError (state, payload) {
    state.error = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
